exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".teacherManager{overflow:hidden}.wrongInfo{margin-bottom:10px}.teacherData,.wrongData{margin-bottom:20px}.teacherManager .uploadBtn{top:130px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-58dedba9!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/xiaoyuan/GX/teacherManage.vue
// module id = 538
// module chunks = 0